export const reframeMoonData = (moon) => {
    const temp = []
    moon && moon.map(i => {
        let data = {
        id: i.id,
        name: i.name,
        diameter: i.diameter + " km",
        mass: i.mass + " kg",
        distanceFromParent: i.distanceFromParent + " km",
        orbitalPeriod: i.orbitalPeriod + " day",
        orbitalInclination: i.orbitalInclination + " °",
        gravity: i.gravity  + "  m/s²",
        minSurfaceTemp: i.surfaceTemps.min + " °C",
        maxSurfaceTemp: i.surfaceTemps.max+ "  °C",
        }

        temp.push(data)
    })

    console.log("reframeMoonData", temp)
    return temp
}

export const reframePlanetData = (planet) => {
    if(planet){
        console.log("reframePlanetData", planet)
        const moon = reframeMoonData(planet.satellites)

        return {
            name: planet.name,
            properties: {
                other_name: planet.other_name,
                diameter: planet.diameter + " km",
                mass: planet.mass + " kg",
                gravity: planet.gravity + " m/s²",
                density: planet.density+" kg/m^3",
                escape : planet.escape + " km/s",
                rotationPeriod: planet.rotationPeriod + " hr",
                lengthOfDay: planet.lengthOfDay + " hr",
                distanceFromParent: planet.distanceFromParent + " km",
                orbitalPeriod: planet.orbitalPeriod + " day",
                orbitalVelocity: planet.orbitalVelocity + " km/s",
                orbitalInclination: planet.orbitalInclination + " °",
                orbitPositionOffset: planet.orbitPositionOffset + " °",
                meanTemperature: planet.meanTemperature + " °C",
                minSurfaceTemp: planet.surfaceTemps.min + " K(kelvin)",
                meanSurfaceTemp: planet.surfaceTemps.mean + " K(kelvin)",
                maxSurfaceTemp: planet.surfaceTemps.max + " K(kelvin)",
                avgTemp: planet.avgTemp + " K(kelvin)",
                rings: planet.rings,
            },
            orbit : {
                semimajorAxis : planet.semimajorAxis + " km",
                perihelion : planet.perihelion + " km",
                aphelion : planet.aphelion + " km",
                eccentricity : planet.eccentricity,
                inclination : planet.inclination + " °",
                sideralOrbit : planet.sideralOrbit + " days",
                sideralRotation : planet.sideralRotation + " hr",
                axialTilt : planet.axialTilt + " °",
            },
            other: {
                meanRadius: planet.meanRadius + " km",
                equaRadius: planet.equaRadius + " km",
                polarRadius: planet.polarRadius + " km",
                flattening: planet.flattening,
                dimension: planet.dimension,
                aroundPlanet: planet.aroundPlanet,
                discoveredBy: planet.discoveredBy,
                discoveryDate: planet.discoveryDate,
                alternativeName: planet.alternativeName,
                mainAnomaly: planet.mainAnomaly,
                argPeriapsis: planet.argPeriapsis,
                longAscNode: planet.longAscNode,
                massValue: planet.mass.massValue + `10${<sub>{planet.mass.massExponent}</sub>}`,
                massExponent: planet["mass"].massExponent,
                volValue: planet.vol.volValue + " km^3",
                volExponent: planet.vol.volExponent,
            },
            satellite: moon,
            manmade_satellite: planet.satellites_mech
        }
    }
}

export const getDesc = (val) => {
    const desc = {
        diameter : "It is the diameter of planet generally measured in km",
        mass : "Mass refers to the amount of matter contained within an object i.e. in Kg",
        gravity: "Gravity is the force by which a planet or other body draws objects toward its center",
        density: "Density is defined as the ratio of the mass of an object to the volume of space the object takes up",
        escape: "The minimum velocity that has to be achieved by an object, to escape the gravitational sphere of influence of the body",
        rotationPeriod: "Time taken by planet to rotate around its axis",
        lengthOfDay: "It it the time taken by planet to rotate around its axis measured in hrs" ,
        distanceFromParent: "The distance of the planet from its star.",
        orbitalPeriod: "The time it takes for an object to orbit around its star",
        orbitalVelocity: "Orbital velocity is the velocity at which a planet revolves around the its star" ,
        orbitalInclination: "Orbital inclination measures the tilt of an planet's orbit around a star",
        orbitPositionOffset: null,
        meanTemperature: "The average temperature across the surface or atmosphere of a planet" ,
        minSurfaceTemp: "The minimum temperature across the surface or atmosphere of a planet",
        meanSurfaceTemp: "The mean temperature across the surface or atmosphere of a planet",
        maxSurfaceTemp: "The maximum temperature across the surface or atmosphere of a planet",
        avgTemp: "The average temperature across the surface or atmosphere of a planet",
        rings: "This suggest that whether planet system has a rings around it or not" ,
        semimajorAxis: "The semi-major axis of a planet is equal to the mean distance of the planet",
        perihelion : "It is refered to the point in the orbit of a planet, at which it is closest to its star",
        aphelion : "It is the point in the orbit of a planet, comet, or other body most distant from its star",
        eccentricity : "A measure of how far a planet's orbit about the Star is from being circular compared to Earth",
        inclination : "The inclination, or tilt, of a planet's orbit is measured in degrees of arc from the plane of Earth's orbit",
        sideralOrbit : "The orbit of a planet around the Star measured with respect to the 'fixed stars' is used to determine the sidereal period",
        sideralRotation : "A sidereal day measures the rotation of Earth relative to the stars rather than the sun" ,
        axialTilt : "Axial tilt, also called obliquity, refers to the angle a planet's rotation axis makes with the plane of its orbit",
        meanRadius: "Mean Radius of planet",
        equaRadius: "Equal Radius of planet",
        polarRadius: "polar Radius of planet",
        flattening:"Flattening is defined as the difference in magnitude between the semimajor axis and the semiminor axis divided by the semimajor axis" ,
        dimension: "That suggests the dimension of planet",
        aroundPlanet:  null,
        discoveredBy:  "The person who made the discovery",
        discoveryDate: "The date in which it was discovered" ,
        alternativeName: "Any other name of planet",
        mainAnomaly: "Anomaly is the angle between lines drawn from the Sun to the perihelion B and to a point (not shown) moving in the orbit at a uniform rate corresponding to the period of revolution of the planet",
        argPeriapsis: "The extreme points on the major axis of the orbit are called the apse points",
        longAscNode: null ,
        massValue: "Mass of planet/object",
        massExponent: "Exponential factor for Mass of planet/object",
        volValue: "Volume of planet/object",
        volExponent: "Exponential factor for Volume of planet/object",
    }
    
    return desc[val] || "Description not available"
}